import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	configuration: {
		id: 'software-deployments.configuration-button.configuration',
		defaultMessage: 'View settings',
		description: 'Button label to configure Deployments view settings.',
	},
	buttonIconLabel: {
		id: 'software-deployments.configuration-button.button-icon-label',
		defaultMessage: 'Configure view icon',
		description: 'Configuration view icon label',
	},
	tooltip: {
		id: 'software-deployments.configuration-button.tooltip',
		defaultMessage: 'View settings',
		description: 'Tooltip describing the content of the button',
	},
});
